import type { CalendarEvent } from '../../shared/contracts';
import { locationMapLinks, prefersAppleMaps } from '../../shared/map-links';
export function MapLinks({
  location,
}: {
  location: NonNullable<CalendarEvent['physicalLocation']>;
}) {
  const links = locationMapLinks(location);
  const apple =
    typeof navigator !== 'undefined' && prefersAppleMaps(navigator.userAgent, navigator.platform);
  const primary = apple && links.apple ? links.apple : links.google;
  if (!primary && !links.provided) return null;
  return (
    <span className="map-links">
      {(primary || links.provided) && (
        <a href={links.provided || primary} rel="noreferrer">
          Open in Maps
        </a>
      )}
    </span>
  );
}
